// Session store - derived from auth and project stores for convenience
// Provides accountId and projectId from current session
import { useAuthStore } from './authStore'
import { useProjectStore } from './projectStore'

interface SessionState {
  accountId: string | null
  projectId: string | null
  isReady: boolean
}

/**
 * Hook to get current session context (accountId and projectId)
 * Derives values from authStore and projectStore
 */
export function useSessionStore(): SessionState {
  const currentAccount = useAuthStore(state => state.currentAccount)
  const currentProject = useProjectStore(state => state.currentProject)

  return {
    accountId: currentAccount?.id ?? null,
    projectId: currentProject?.id ?? null,
    isReady: !!(currentAccount?.id && currentProject?.id),
  }
}
